export class CreditLimit {
    id: number = -1;
    accountId: number = -1;
    usedCredit: number = 0.0;
    maxCredit: number = 0.0;
    createdAt: string = '';
    updatedAt: string = '';
}